<template lang="pug">
  .columns
    .column.col-3.col-lg-4.col-md-6.col-xs-12.mb-2
      box(@click="navigateTo('reports.balances.month.purchases')" title="Ganhos no mês" :value="value.gains | currency('R$ ')" icon="fas fa-money-bill-alt" box-style="success")
    .column.col-3.col-lg-4.col-md-6.col-xs-12.mb-2
      box(@click="navigateTo('filiationSubscriptions.list')" title="Assinaturas no mês" :value="value.filiationSubscriptions" icon="fas fa-check-square" box-style="primary")
    .column.col-3.col-lg-4.col-md-6.col-xs-12.mb-2
      box(@click="navigateTo('filiationPurchases.list')" title="Compras no mês" :value="value.filiationPurchases" icon="fas fa-shopping-cart" box-style="danger")
    .column.col-3.col-lg-4.col-md-6.col-xs-12.mb-2
      box(@click="navigateTo('filiationAccess.list')" title="Acessos no mês" :value="value.filiationAccess" icon="fas fa-mouse-pointer" box-style="warning")
</template>

<script>
export default {
  props: {
    value: { type: Object, default: () => ({}) },
  },

  methods: {
    navigateTo(name) {
      this.$router.push({ name })
    },
  },
}
</script>
